<span class="status">
  @switch (status) {
    @case (IdentifierStatus.Verified) {
      <img alt="" src="/assets/default/input-approved.svg">
    }
    @case (IdentifierStatus.Pending) {
      <img alt="" src="/assets/default/clock.svg">
    }
    @case (IdentifierStatus.Suspended) {
      <img alt="" src="/assets/default/input-error.svg">
    }
  }
  {{ IdentifierStatusPresentation(status) }}
</span>
